export const blockIconsSearchLight = (
	<span className='material-symbols-outlined'>light</span>
);
